export const SLACK_OAUTH_STATE_KEY = 'slack_oauth_state'

/**
 * Generate a random state string for OAuth security.
 */
export const generateSlackOAuthState = (): string => {
  // Generate secure random state
  const array = new Uint8Array(32)
  crypto.getRandomValues(array)
  const state = Array.from(array, (byte) =>
    byte.toString(16).padStart(2, '0')
  ).join('')

  return state
}

/**
 * Save the OAuth state to sessionStorage for later verification.
 * This method can only be called on the client-side.
 */
export const saveSlackOAuthState = (state: string): void => {
  if (typeof window === 'undefined') {
    throw new Error('saveSlackOAuthState can only be called in the browser')
  }

  window.sessionStorage.setItem(SLACK_OAUTH_STATE_KEY, state)
}

/**
 * Verify the state parameter returned from Slack OAuth.
 * This method can only be called on the client-side.
 */
export const verifySlackOAuthState = (receivedState: string): boolean => {
  if (!receivedState) {
    return false
  }

  if (typeof window === 'undefined') {
    return false
  }

  const storedState = window.sessionStorage.getItem(SLACK_OAUTH_STATE_KEY)
  if (!storedState) {
    return false
  }

  // Clean up stored state after verification
  window.sessionStorage.removeItem(SLACK_OAUTH_STATE_KEY)

  return storedState === receivedState
}
